module.exports = __webpack_public_path__ + "img/img-classify12.40bb8118.png";